import { render } from "./ReportIssueMenuItem.vue?vue&type=template&id=3bb4784d"
import script from "./ReportIssueMenuItem.vue?vue&type=script&lang=js"
export * from "./ReportIssueMenuItem.vue?vue&type=script&lang=js"

import "./ReportIssueMenuItem.vue?vue&type=style&index=0&id=3bb4784d&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__